import React from "react";
import {Chip} from "@material-ui/core";

const ChipLabel = ({label, className, ...props}) => {
    return (
        <React.Fragment>
            {
                label && <Chip size="small" label={label} className={className} {...props}/>
            }
        </React.Fragment>
    )
}

export default ChipLabel;